import React from 'react';
import { Form } from 'react-bootstrap';
import { SyncLoader } from 'react-spinners';

function ToggleSwitch({ isLoading, checked, onChange }) {
  return (
    <Form>
      {
        isLoading ?
          <SyncLoader
            size={6}
            color={"#6162e5"}
            speedMultiplier={0.6}
          />
          :
          <Form.Check
            type="switch"
            checked={checked}
            onChange={onChange}
          />
      }
    </Form>
  );
}

export default ToggleSwitch;
